"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.filter");

var _toConsumableArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = exports.useBreadcrumb = exports.BreadcrumbProvider = exports.BreadcrumbContext = void 0;

var antd_1 = require("antd");

var orderBy_1 = __importDefault(require("lodash/orderBy"));

var path_1 = __importDefault(require("path"));

var react_1 = __importStar(require("react"));

var react_router_dom_1 = require("react-router-dom");

exports.BreadcrumbContext = react_1["default"].createContext({
  activeCrumbs: [],
  addCrumb: function addCrumb() {},
  removeCrumb: function removeCrumb() {}
});

function BreadcrumbProvider(_ref) {
  var children = _ref.children;

  var _ref2 = (0, react_1.useState)([]),
      _ref3 = _slicedToArray(_ref2, 2),
      activeCrumbs = _ref3[0],
      setActiveCrumbs = _ref3[1];

  var value = {
    activeCrumbs: activeCrumbs,
    addCrumb: function addCrumb(info) {
      setActiveCrumbs(function (crumbs) {
        return [].concat(_toConsumableArray(crumbs), [info]);
      });
    },
    removeCrumb: function removeCrumb(href) {
      setActiveCrumbs(function (crumbs) {
        return crumbs.filter(function (crumb) {
          return crumb.href !== href;
        });
      });
    }
  };
  return react_1["default"].createElement(exports.BreadcrumbContext.Provider, {
    value: value,
    children: children
  });
}

exports.BreadcrumbProvider = BreadcrumbProvider;

function useBreadcrumb(info, key) {
  var href = (0, react_router_dom_1.useResolvedPath)('').pathname;

  var _ref4 = (0, react_1.useContext)(exports.BreadcrumbContext),
      addCrumb = _ref4.addCrumb,
      removeCrumb = _ref4.removeCrumb;

  (0, react_1.useEffect)(function () {
    if (Array.isArray(info)) {
      var resolvedItems = info.map(function (item) {
        return Object.assign(Object.assign({}, item), {
          href: item.href ? item.href : item.relativeHref ? path_1["default"].resolve(href, item.relativeHref) : href
        });
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = resolvedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          addCrumb(item);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return function () {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = resolvedItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;
            removeCrumb(item.href);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      };
    } else {
      addCrumb(Object.assign(Object.assign({}, info), {
        href: href
      }));
      return function () {
        removeCrumb(href);
      };
    }
  }, [key]);
}

exports.useBreadcrumb = useBreadcrumb;

function Breadcrumbs() {
  var _ref5 = (0, react_1.useContext)(exports.BreadcrumbContext),
      activeCrumbs = _ref5.activeCrumbs;

  var sorted = (0, orderBy_1["default"])(activeCrumbs, function (crumb) {
    return crumb.href.length;
  });
  return react_1["default"].createElement(antd_1.Breadcrumb, null, sorted.map(function (crumb) {
    return react_1["default"].createElement(antd_1.Breadcrumb.Item, {
      key: crumb.href
    }, react_1["default"].createElement(react_router_dom_1.Link, {
      to: crumb.href
    }, crumb.title));
  }));
}

exports.Breadcrumbs = Breadcrumbs;